import styled from "styled-components";
import background from "../assets/background.png";

const AssignmentsContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    padding-top: 40px;
    padding-bottom: 40px;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    overflow-y: auto;

    h1 {
        color: #673c8c;
        margin: 0;
        margin-bottom: 0.25em;
        font-size: 4em;
    }

    div:only-child{
        margin: auto 0;
    }

    div.top{
        margin-top: auto;
    }

    div.bottom{
        margin-bottom: auto;
    }
`;

const AssignmentContainer = styled.div`
    width: 100%;
    margin-bottom: 40px;
    border: 2px solid #683d8c;
    border-top: 0;
    border-radius: 1em;
    background: white;

    h3 {
        font-size: 3em;
        color: #683d8c;
        background: #e1d9e8;
        padding: 0.4em;
        margin: 0;
        text-align: center;
        border-top: 2px solid #683d8c;
        border-radius: 0.5em;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

const ImportantAssignmentContainer = styled.div`
    width: 100%;
    margin-bottom: 40px;
    border: 2px solid #eb0000;
    border-top: 0;
    border-radius: 1em;
    background: white;

    h3 {
        font-size: 3em;
        color: #eb0000;
        background: #ff928a;
        padding: 0.4em;
        margin: 0;
        text-align: center;
        border-top: 2px solid #eb0000;
        border-radius: 0.5em;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

const AssignmentCompleteContainer = styled.div`
    width: 100%;
    margin-bottom: 40px;
    border: 2px solid #009c08;
    border-top: 0;
    border-radius: 1em;
    background: white;

    h3 {
        font-size: 3em;
        color: #009c08;
        background: #9ad69d;
        padding: 0.4em;
        margin: 0;
        text-align: center;
        border-top: 2px solid #009c08;
        border-radius: 0.5em;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

const AssignmentUpcomingContainer = styled.div`
    width: 100%;
    margin-bottom: 40px;
    border: 2px solid #a1a1a1;
    border-top: 0;
    border-radius: 1em;
    background: white;

    h3 {
        font-size: 3em;
        color: #a1a1a1;
        background: #dedede;
        padding: 0.4em;
        margin: 0;
        text-align: center;
        border-top: 2px solid #a1a1a1;
        border-radius: 0.5em;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

const InfoPane = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em;

    @media (min-width: 1441px) {
        padding: 3em;
    }
`;

const StatContainer = styled.div`
    width: 35%;
    display: flex;
    align-items: center;

    span {
        background: ${props => props.dark};
        padding: 0.25em;
        padding-left: 0.25em;
        padding-left: 1.5em;
        margin-left: -1em;
        margin-right: 1.5em;
        5em;
        width: 100%;
        color: white;
        font-size: 1.5em;
        border-radius: 0.25em;
        font-weight: bold;

        @media (min-width: 1025px) and (max-width: 1440px) {
            padding: 0.55em;
            padding-left: 2em;
            border-radious: 0.5em;
        }

        @media (min-width: 1441px) {
            padding: 0.5em;
            padding-left: 1.5em;
            font-size: 1.75em;
            border-radius: 0.5em;
        }
    }
`;

const IconContainer = styled.div`
    background: ${props => props.light};
    padding: 0.25em;
    border-radius: 2.5em;
    width: 5.5em;
    height: 4.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;

    img {
        width: 3em;
        height: 3em;
    }

    @media (min-width: 1025px) and (max-width: 1440px) {
        padding: 0.5em;
        border-radius: 3.5em;
        width: 6.5em;
    }

    @media (min-width: 1441px) {
        width: 7.5em;
        height: 6.5em;
        border-radius: 3.5em;
    }
`;

export {
    AssignmentsContainer,
    AssignmentContainer,
    ImportantAssignmentContainer,
    AssignmentCompleteContainer,
    AssignmentUpcomingContainer,
    InfoPane,
    StatContainer,
    IconContainer
};
